
import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
import { Component, Injector, Renderer2 } from '@angular/core';
import { ComponentFactoryResolver, ChangeDetectorRef } from '@angular/core';

import { DynamicBaseComponent } from '../dynamic-base.component';

@Component({
    selector: 'tooltip-overlay',
    template: `<div class="container"
    [style.top]="cntr_box?.top + 'px'"
    [style.left]="cntr_box?.left + 'px'"
    [style.width]="cntr_box?.width + 'px'"
    [style.height]="cntr_box?.height + 'px'"
    [style.z-index]="model?.data?.zIndex || 3000">

    <div *ngIf="(rendered || model.template) && shown" [@show]="model.position" [class]="'tooltip ' + model.position + ' ' + model.name + (!model.triangle ? ' no-triangle': '')" widget
        [class.no-triangle]="!model.triangle"
        (window:click)="shown ? close($event) : ''"
        (window:resize)="shown ? resize($event) : ''"
        (click)="tap()">
        <div #body [class]="'content ' + model.offset" (click)="tap()">
            <ng-container #content></ng-container>
            <ng-container *ngTemplateOutlet="model.template"></ng-container>
        </div>
        <div class="triangle"><div class="square"></div></div>
    </div>
</div>`,
    styles: [`.tap-area{position:fixed;top:0;left:0;right:0;bottom:0;pointer-events:auto}.container{position:fixed;pointer-events:none}.tooltip{position:absolute;z-index:3000;-webkit-transition:opacity .3s;transition:opacity .3s;display:initial}.tooltip.no-triangle{width:0}.tooltip.no-triangle .triangle{display:none}.tooltip.left,.tooltip.right{top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);height:32px;width:8px}.tooltip.left.no-triangle,.tooltip.right.no-triangle{width:0}.tooltip.left{left:-8px}.tooltip.left.no-triangle{left:-4px}.tooltip.right{right:-8px}.tooltip.right.no-triangle{right:-4px}.tooltip.bottom,.tooltip.top{left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);height:8px;width:32px}.tooltip.bottom.no-triangle,.tooltip.top.no-triangle{height:0}.tooltip.top{top:-8px}.tooltip.top.no-triangle{top:-4px}.tooltip.top.no-triangle.dropdown-list{top:0}.tooltip.bottom{bottom:-8px}.tooltip.bottom.no-triangle{bottom:-4px}.tooltip.bottom.no-triangle.dropdown-list{bottom:0}.tooltip.none .content{background:0 0;-webkit-box-shadow:none;box-shadow:none;border-radius:none}.dropdown-list .content{background-color:0;-webkit-box-shadow:none;box-shadow:none}.content{position:absolute;background-color:#fff;-webkit-box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);min-height:16px;min-width:16px;border-radius:4px;pointer-events:auto}.clear .content{-webkit-box-shadow:none;box-shadow:none;background:0 0}.left .content{right:0;-webkit-transform:translate(-8px,0);transform:translate(-8px,0)}.left .content.middle{top:50%;-webkit-transform:translate(-8px,-50%);transform:translate(-8px,-50%)}.right .content{left:0;-webkit-transform:translate(8px,0);transform:translate(8px,0)}.right .content.middle{top:50%;-webkit-transform:translate(8px,-50%);transform:translate(8px,-50%)}.left .content.start,.right .content.start{top:0}.left .content.end,.right .content.end{bottom:0}.top .content{top:0;-webkit-transform:translate(0,-100%);transform:translate(0,-100%)}.top .content.middle{left:50%;-webkit-transform:translate(-50%,-100%);transform:translate(-50%,-100%)}.bottom .content{bottom:0;-webkit-transform:translate(0,100%);transform:translate(0,100%)}.bottom .content.middle{left:50%;-webkit-transform:translate(-50%,100%);transform:translate(-50%,100%)}.bottom .content.start,.top .content.start{left:0}.bottom .content.end,.top .content.end{right:0}.triangle{position:relative;overflow:hidden}.left .triangle,.right .triangle{height:32px;width:8px}.bottom .triangle,.top .triangle{height:8px;width:32px}.triangle .square{position:absolute;height:32px;width:32px;border-radius:2px;-webkit-transform:rotate(45deg);transform:rotate(45deg);background-color:#fff;-webkit-box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12)}.left .triangle .square{top:0;right:8px}.right .triangle .square{top:0;left:8px}.top .triangle .square{bottom:8px;left:0}.bottom .triangle .square{top:8px;left:0}`],
    animations: [
        trigger('show', [
            transition('void => top', [style({ opacity: 0, top: '16px' }), animate(100, style({ opacity: 1, top: '*' }))]),
            transition('void => left', [style({ opacity: 0, left: '16px' }), animate(100, style({ opacity: 1, left: '*' }))]),
            transition('void => right', [style({ opacity: 0, right: '16px' }), animate(100, style({ opacity: 1, right: '*' }))]),
            transition('void => bottom', [style({ opacity: 0, bottom: '16px' }), animate(100, style({ opacity: 1, bottom: '*' }))]),
        ]),
    ],
})
export class TooltipComponent extends DynamicBaseComponent {
    public shown = false;
    public mouse_state = 'up';

    protected type = 'Tooltip';

    private listeners: any[] = [];

    constructor(private injector: Injector) {
        super();
        this._cfr = this.injector.get(ComponentFactoryResolver);
        this._cdr = this.injector.get(ChangeDetectorRef);
        this.renderer = this.injector.get(Renderer2);
    }

    public init(parent?: any, id?: string): void {
        super.init(parent, id);
        this.updateListeners();
        setTimeout(() => this.resize(), 300);
    }

    public resize(show: boolean = false, tries: number = 0): void {
        super.resize();
        if (!show) { this.shown = false; }
        const el = this.model.el;
        if (el && el.nativeElement) {
            const cnt = el.nativeElement.getBoundingClientRect();
            this.updatePosition();
            this.cntr_box = {
                height: cnt.height,
                width: cnt.width,
                top: cnt.top,
                left: cnt.left
            } as ClientRect;
            if (((cnt.x + cnt.width) < 0 && (cnt.y + cnt.height) < 0) ||
                ((cnt.x + cnt.width) < 0 && cnt.y > window.innerHeight) ||
                (cnt.x > window.innerWidth && (cnt.y + cnt.height) < 0) ||
                (cnt.x > window.innerWidth && cnt.y > window.innerHeight)) {
                return this.event('close', 'Outside');
            }
            // Add offset for container location
            if (this.parent.root && this.parent.root.nativeElement) {
                const box = this.parent.root.nativeElement.getBoundingClientRect();
                this.cntr_box.top -= box.top;
                this.cntr_box.left -= box.left;
            } else if (this.parent.id !== 'root') {
                return <any>setTimeout(() => this.resize(true, tries + 1), 200);
            }
            setTimeout(() => this.shown = true, 50);
        }
        const cntr = this.cntr_box;
        if (!el || !cntr || ((cntr.height <= 0 || cntr.width <= 0) && cntr.top <= 0)) {
            setTimeout(() => this.resize(true, tries + 1), 200);
        }
    }

    private updateListeners(): void {
        for (const l of this.listeners) {
            if (l) { l(); }
        }
        this.listeners = [];
        if (this.model.el) {
            let el = this.model.el.nativeElement.parentElement;
            for (; !!el; el = el.parentElement) {
                this.listeners.push(this.renderer.listen(el, 'scroll', () => {
                    if (this.shown) { this.resize(true); }
                }));
            }
        }
        this.resize();
    }

    private updatePosition() {
        this.timeout('position', () => {
            // Initialise model if it is falsy
            if (!this.model) { this.model = {}; }
            if (!this.cntr_box) {
                return this.resize();
            }
            if (!this.model.preferences) {
                this.model.preferences = {
                    position: this.model.position || 'bottom',
                    offset: this.model.offset || 'middle'
                };
            }
            // Initialise tooltip positioning
            this.model.position = (this.model.preferences ? this.model.preferences.position : this.model.position) || this.model.position;
            this.model.offset = (this.model.preferences ? this.model.preferences.offset : this.model.offset) || this.model.offset;
            // Compare parent to window to determine tooltip position
            const w = window.innerWidth;
            const h = window.innerHeight;
            if (this.model.position === 'bottom' || this.model.position === 'top' || this.model.position === 'auto') {
                // Position along Y axis
                if (this.cntr_box.top < h / 8) {
                    this.model.position = 'bottom';
                } else if (this.cntr_box.top + this.cntr_box.height > h - h / 8) {
                    this.model.position = 'top';
                }
            } else if (this.model.position === 'left' || this.model.position === 'right') {
                // Position along X axis
                if (this.cntr_box.left < w / 8) {
                    this.model.position = 'right';
                } else if (this.cntr_box.left + this.cntr_box.width > w - w / 8) {
                    this.model.position = 'left';
                }
            }
            // Set to default position if still auto
            if (this.model.position === 'auto') { this.model.position = 'bottom'; }
            if (this.model.offset === 'auto') {
                const dim = {
                    l: this.model.position === 'bottom' || this.model.position === 'top' ? w : h,
                    p: this.model.position === 'bottom' || this.model.position === 'top' ? this.cntr_box.left : this.cntr_box.top,
                    s: this.model.position === 'bottom' || this.model.position === 'top' ? this.cntr_box.width : this.cntr_box.height
                };
                if (dim.p < dim.l / 8) {
                    this.model.offset = 'start';
                } else if (dim.l + dim.s > dim.l - dim.l / 8) {
                    this.model.offset = 'end';
                }
            }
            // Set to default offset if still auto
            if (this.model.offset === 'auto') { this.model.offset = 'middle'; }
        }, 20)
    }

    protected update(data: any): void {
        super.update(data);
        setTimeout(() => this.updateListeners(), 200);
    }
}
